import React from "react";
import {
    Box,
    Checkbox,
    Typography,
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const UncheckedIcon = styled('span')(({ theme }) => ({
    width: '12px',
    height: '12px',
    borderRadius: '2px',
    border: '1px solid rgba(139, 142, 146, 1)',
    'input:hover ~ &': {
        borderColor: 'rgba(178, 235, 177, 1)', // hover color
    },
    'input:disabled ~ &': {
        borderColor: 'rgb(139, 142, 146)',
    },
}));

const CheckedIcon = styled(UncheckedIcon)(({ theme }) => ({
    backgroundColor: 'rgb(0, 0, 0)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    'input:hover ~ &': {
        backgroundColor: 'rgba(178, 235, 177, 1)',
    },
    'input:disabled ~ &': {
        backgroundColor: 'rgb(139, 142, 146)',
    },
    '& svg': {
        fontSize: 12,
        stroke: 'rgba(255, 255, 255, 1)',
        strokeWidth: 2,
        'input:hover ~ &': {
            stroke: 'rgba(0, 0, 0, 1)',
        },
        'input:disabled ~ &': {
            stroke: 'rgba(0, 0, 0, 1)',
        },
    },
}));

function BaseCheckbox(props) {

    return (
        <Checkbox
            icon={<UncheckedIcon />}
            checkedIcon={<CheckedIcon><Check /></CheckedIcon>}
            sx={{
                padding: 0,
                margin: 0,
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }}
            {...props}
        />
    )
}

export default BaseCheckbox;